'use client';

import { usePathname } from 'next/navigation';

import { MY_LIBRARY_PATH } from '@/constants/my-library-route';
import Footer from '@/components/footer';
import VrnfestFooter from '@/components/footer/vrnfest-footer';
import Header from '@/components/header';

interface ConditionalLayoutWrapperProps {
  children: React.ReactNode;
}

export default function ConditionalLayoutWrapper({ children }: ConditionalLayoutWrapperProps) {
  const pathname = usePathname();

  // Skip header/footer for staging auth page
  if (pathname === '/staging-auth') {
    return <>{children}</>;
  }

  if (pathname === '/tg' || pathname.startsWith('/tg')) {
    return <>{children}</>;
  }

  const isFanficReadPage = /^\/fanfics\/\d+\/read$/.test(pathname);
  if (isFanficReadPage) {
    return <>{children}</>;
  }

  const isAuthorDashboard = pathname === '/author-dashboard';
  const isProfilePage = pathname === '/profile' || pathname.startsWith('/profile/');
  const isMyLibraryPage = pathname === MY_LIBRARY_PATH;
  const isEditFanficPage = pathname.startsWith('/edit-fanfic/');
  const needsLightBackground =
    isAuthorDashboard || isProfilePage || isMyLibraryPage || isEditFanficPage;

  const isVrnfestPage = pathname === '/vrnfest' || pathname.startsWith('/vrnfest/');
  const isOriginalPlusPage = pathname === '/original_plus';

  return (
    <div
      className={`min-h-screen flex flex-col ${
        isVrnfestPage ? 'bg-[#1B1D22]' : isOriginalPlusPage ? 'bg-[#120018]' : 'bg-background'
      }`}
    >
      <div className="relative z-30">
        <Header />
      </div>
      <div
        className="content-container relative z-5 flex flex-col flex-1 w-full"
        style={{
          maxWidth: '1920px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <main
          className={`flex-1 w-full ${needsLightBackground ? 'bg-background' : ''}`}
          style={{ maxWidth: '100%' }}
        >
          {children}
        </main>
      </div>
      <div className="relative z-30">{isVrnfestPage ? <VrnfestFooter /> : <Footer />}</div>
      {/* Modals */}
    </div>
  );
}
